<div class="overflow-auto">
    <table class="table table-bordered text-center">
        <thead>
            <tr>
                <th scope="col">ID solicitud</th>
                <th scope="col">Trayecto</th>
                <th scope="col">Origen</th>
                <th scope="col">Destino</th>
                <th scope="col">Hora salida</th>
                <th scope="col">Hora llegada</th>
                <th scope="col">Fecha solicitud del servicio</th>
                <th scope="col">Fecha de prestación del servicio</th>
                <th scope="col">Estado</th>
                <th scope="col">Acciones</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of dataTable">
                <td>{{data.id}}</td>
                <td>{{data.vcTrayecto}}</td>
                <td>{{data.vcLugarSalida}} </td>
                <td>{{data.vcLugarDestino}} </td>
                <td>{{data.dtHoraSalida}} </td>
                <td>{{data.dtHoraRegreso}} </td>
                <td>{{data.dtFechaSolicitud}} </td>
                <td>{{data.dtFechaPrestacionServicio}} </td>
                <td>{{data.vcEstado}} </td>
                <td>
                    <div class="d-flex flex-row gap-1">
                        <button class="btn btn-outline-secondary btn-sm" (click)="selectSolicitud(data.id)" placement="top" ngbTooltip="Consultar">
                            <i class="fa-sharp fa-solid fa-file-lines"></i>
                        </button>
                        <button class="btn btn-outline-secondary btn-sm" [routerLink]="['/ajuste-solicitud/', data.id]" placement="top" ngbTooltip="Editar">
                            <i class="fa-sharp fa-solid fa-pen-to-square"></i>
                        </button>
                        <button class="btn btn-outline-secondary btn-sm" (click)="onCancel(true, data)" placement="top" ngbTooltip="Cancelar">
                            <i class="fa-sharp fa-solid fa-xmark"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>